import { createAsyncThunk } from "@reduxjs/toolkit";
import Sessions from "utils/Sessions";
import ApiService from "../ApiService/ApiService";

const uploadImageThunk = createAsyncThunk(
  "files/upload",
  async ({ file, type, allowedMimeTypes }) => {
    const formData = new FormData();
    formData.append("type", type);
    if (allowedMimeTypes?.length) {
      formData.append("allowedMimeTypes", JSON.stringify(allowedMimeTypes));
    }
    formData.append("file", file);
    const res = await ApiService.post("upload", formData, {
      headers: {
        Authorization: `Bearer ${Sessions.userToken}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  }
);
export default uploadImageThunk;
